export const RESPONSIVE_NOTE_PHOTO_KEYS = {
  all: () => ["responsiveNotePhotos"] as const,
  estimate: (estimateId: string) => [...RESPONSIVE_NOTE_PHOTO_KEYS.all(), "estimate", estimateId] as const,
  estimateLabels: (estimateId: string) => [...RESPONSIVE_NOTE_PHOTO_KEYS.all(), "estimateLabels", estimateId] as const,
};
